export const TextareaPanelType = {
	edit: 'edit',
	reply: 'reply',
	forward: 'forward',
	market: 'market',
	none: '',
};
